module.exports = __webpack_public_path__ + "img/lightbulbs.dccb0da.png";